export abstract class PaymentUtils {
  static async createPaymentIntent(transactionIds: number[]): Promise<{ paymentProviderId: string }> {
    const response = await fetch(`/api/customer/payment-intents`, {
      method: 'POST',
      body: JSON.stringify({ transactionIds })
    });
    if (!response.ok) throw new Error('Could not create payment intent');
    return response.json();
  }
}
